import React from "react";

const Clients = () => {
  return (
    <div class="mb-10">
      <section className="relative h-[40vh] bg-[rgb(242,232,232)]">
        <h1 className="text-2xl text-[#7a3432] font-semibold drop-shadow-lg mt-6 py-8 ">
          Our Clients
        </h1>
        <div className="flex flex-wrap justify-center py-5">
          <img
            decoding="async"
            className="skip-lazy mb-4 mr-4"
            src="https://www.merzconsulting.com.au/wp-content/uploads/2021/06/covalentLithium@3x.png"
            alt="covalentLithium@3x"
            width="235"
            height="102"
          />
          <img
            decoding="async"
            className="skip-lazy mb-4 mr-4"
            src="https://www.merzconsulting.com.au/wp-content/uploads/2020/06/horizonpower@3x-e1592470586209.png"
            alt="Horizon Power - MERZ Consulting"
            width="235"
            height="102"
          />
          <img
            fetchpriority="high"
            decoding="async"
            className="skip-lazy mb-4 mr-4"
            src="https://www.merzconsulting.com.au/wp-content/uploads/2020/05/horizonpower@2x.png"
            alt="horizonpower@2x"
            width="235"
            height="102"
          />
        </div>
      </section>
      <section class="w-full h-[30vh]">
        <img
          decoding="async"
          class="w-full max-h-[40vh] object-cover shadow-black"
          alt="pic"
          src="https://merzconsulting.com.au/wp-content/uploads/2020/08/home_img.jpg"
          data-src="https://merzconsulting.com.au/wp-content/uploads/2020/08/home_img.jpg"
          data-object-fit="cover"
        />
      </section>
    </div>
  );
};

export default Clients;
